/*
 * SPDX-License-Identifier: Apache-2.0
 *
 * The OpenSearch Contributors require contributions made to
 * this file be licensed under the Apache-2.0 license or a
 * compatible open source license.
 *
 * Modifications Copyright OpenSearch Contributors. See
 * GitHub history for details.
 */

/*
 * Licensed to Elasticsearch B.V. under one or more contributor
 * license agreements. See the NOTICE file distributed with
 * this work for additional information regarding copyright
 * ownership. Elasticsearch B.V. licenses this file to you under
 * the Apache License, Version 2.0 (the "License"); you may
 * not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import { cloneElement } from 'react';
import PropTypes from "prop-types";
import classNames from 'classnames';
export var OuiGlobalToastListItem = ({
  children,
  isDismissed
}) => {
  if (!children) {
    return null;
  }
  const classes = classNames('ouiGlobalToastListItem', children.props.className, {
    'ouiGlobalToastListItem-isDismissed': isDismissed
  });
  return cloneElement(children, {
    ...children.props,
    ...{
      className: classes
    }
  });
};
OuiGlobalToastListItem.propTypes = {
  className: PropTypes.string,
  "aria-label": PropTypes.string,
  "data-test-subj": PropTypes.string,
  isDismissed: PropTypes.bool,
  /**
     * ReactElement to render as this component's content
     */
  children: PropTypes.element
};
try {
  OuiGlobalToastListItem.__docgenInfo = {
    tags: {},
    filePath: '/codebuild/output/src2210237963/src/src/components/toast/global_toast_list_item.tsx',
    description: '',
    displayName: 'OuiGlobalToastListItem',
    methods: [],
    props: {
      className: {
        defaultValue: null,
        description: '',
        name: 'className',
        parent: {
          fileName: 'src/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'src/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      'aria-label': {
        defaultValue: null,
        description: '',
        name: 'aria-label',
        parent: {
          fileName: 'src/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'src/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      'data-test-subj': {
        defaultValue: null,
        description: '',
        name: 'data-test-subj',
        parent: {
          fileName: 'src/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'src/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      isDismissed: {
        defaultValue: null,
        description: '',
        name: 'isDismissed',
        parent: {
          fileName: 'src/src/components/toast/global_toast_list_item.tsx',
          name: 'OuiGlobalToastListItemProps'
        },
        declarations: [{
          fileName: 'src/src/components/toast/global_toast_list_item.tsx',
          name: 'OuiGlobalToastListItemProps'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      children: {
        defaultValue: null,
        description: "ReactElement to render as this component's content",
        name: 'children',
        parent: {
          fileName: 'src/src/components/toast/global_toast_list_item.tsx',
          name: 'OuiGlobalToastListItemProps'
        },
        declarations: [{
          fileName: 'src/src/components/toast/global_toast_list_item.tsx',
          name: 'OuiGlobalToastListItemProps'
        }, {
          fileName: 'src/node_modules/@types/react/index.d.ts',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'ReactElement<any, string | JSXElementConstructor<any>>'
        }
      }
    },
    extendedInterfaces: ['CommonProps', 'OuiGlobalToastListItemProps']
  };
} catch (e) {}